import { Notification, NotificationSize, NotificationType } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../translations';

export const IntegrationSettingInfoNotification = (): JSX.Element => {
   return (
      <Notification
         size={NotificationSize.SMALLER}
         type={NotificationType.INFO}
         label={nfzSettingsTranslationKeys.integrationConfigurationAvailableOnceNfzDataIsEntered}
         testId={'ewusLoginDataClear'}
      />
   );
};
